import * as React from "react"
import {
  composeRenderProps,
  Input as InputPrimitive,
} from "react-aria-components"

import { cn } from "@/lib/utils"

function Input({
  className,
  type,
  ...props
}: React.ComponentProps<typeof InputPrimitive>) {
  return (
    <InputPrimitive
      type={type}
      data-slot="input"
      className={composeRenderProps(className, (className) =>
        cn(
          // The outline uses `border-border` (NOT `border-input`): `--input` doubles as the subtle fill tint and equals
          // `--card` in dark, so an `border-input` outline vanishes on drawer/card surfaces. `--input` stays for the fill.
          // FOCUS: a SINGLE flush outline in the brand `--primary` (red for Takeda in BOTH themes; the blue tenants keep
          // their brand blue — `--primary` == the old accent for them). `border-primary` + a flush `ring-1 ring-primary`
          // read as one crisp 2px line — no soft `/50` halo doubling the border.
          // ⚠ OWNER-ACCEPTED AA DEVIATION (brand review, debate/code-brand-fix.md): routing the focus ring through the
          // saturated brand instead of the AA-safe `--ring`/`--brand-interactive` partner makes it ~2.5:1 vs Takeda's
          // dark surface — below WCAG SC 1.4.11's 3:1 for focus indicators. Chosen for brand consistency (owner: a11y is
          // a plus here, not a hard requirement); the crisp red matches the buttons. Revert to `ring-ring` for strict AA.
          "h-8 w-full min-w-0 rounded-lg border border-border bg-transparent px-2.5 py-1 text-base transition-colors outline-none file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:border-primary focus-visible:ring-1 focus-visible:ring-primary disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 md:text-sm dark:bg-input/30 dark:disabled:bg-input/80 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40",
          className
        )
      )}
      {...props}
    />
  )
}

export { Input }
